// extracted by mini-css-extract-plugin
export default {"container":"QY-z","leftColumn":"RY-z","rightColumn":"SY-z","item":"TY-z"};